import { useCallback } from 'react'

import { useDriverAssignmentEditMode, useEditingStateWithCtx } from '@/atoms'
import { cancelCreateLocalDriverAssignment } from '@/features/domain/driverAssignments'
import { useNotification } from '@/hooks'
import { useAppDispatch } from '@/store'

export function useOnCancel(recurrence: string) {
  const { resetEditing } = useEditingStateWithCtx('driversAssignment')
  const dispatch = useAppDispatch()
  const toast = useNotification()
  const [editMode, setEditMode] = useDriverAssignmentEditMode()

  return useCallback(async () => {
    try {
      if (editMode === 'create') {
        const result = await dispatch(cancelCreateLocalDriverAssignment(recurrence))

        if (!cancelCreateLocalDriverAssignment.fulfilled.match(result)) {
          throw new Error(result.payload?.message ?? 'Internal error')
        }
      }

      setEditMode('reset')
      resetEditing()
    } catch (e) {
      toast.error(e.message)
    }
  }, [dispatch, toast, resetEditing, recurrence, editMode, setEditMode])
}
